import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BugReportDialogComponent } from './bug-report-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    BugReportDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    BugReportDialogComponent
  ],
  providers: [],
})
export class BugReportDialogModule {}
